export default __webpack_public_path__ + "static/media/1.85cd1e91.svg";